import { createAction, props } from "@ngrx/store";
import { ERoundState, IRoundBet, IRoundInitialState } from "../interfaces";
import { IAutoplayOptions } from "./interfaces";

enum ERoundActions {
    AddRound = "Add Round",
    ClearRound = "Clear Round",
    ChangeState = "Change State",
    AddBets = "Add Bets",
    UpdateBets = "Update Bets",
    RemoveBets = "Remove Bets",
    UpdateMultiplier = "Update Multiplier",
    AddUserBet = "Add User Bet",
    ConfirmUserBet = "Confirm User Bet",
    RemoveUserBet = "Remove User Bet",
    SetAutoplayOptions = "Set Autoplay Options",
    RemoveAutoplayOptions = "Remove Autoplay Options",
    InitialStateUpdate = "Initial State Update",
    FirstHalfCashedOut = "First Half Cash Out"
}

export const addUserBet = createAction(ERoundActions.AddUserBet, props<{ data: { amount: number, betIndex: number, maxMultiplier: number | undefined, roundId: string | undefined } }>());
export const removeUserBet = createAction(ERoundActions.RemoveUserBet, props<{ betIndex: number, isCashOut: boolean, skipAutoplayOptionsRemoving: boolean }>());
export const addRound = createAction(ERoundActions.AddRound, props<{ id: string }>());
export const userBetConfirmed = createAction(ERoundActions.ConfirmUserBet, props<{ roundId: string, betIndex: number }>());
export const firstHalfCashedOut = createAction(ERoundActions.FirstHalfCashedOut, props<{ roundId: string, betIndex: number, amount: number }>());
export const changeState = createAction(ERoundActions.ChangeState, props<{ state: ERoundState, multiplier?: number }>());
export const addBets = createAction(ERoundActions.AddBets, props<{ bets: IRoundBet[], totalBets: number }>());
export const updateBets = createAction(ERoundActions.UpdateBets, props<{ bets: Partial<IRoundBet>[] }>());
export const removeBets = createAction(ERoundActions.RemoveBets, props<{ ids: string[], totalBets: number }>());
export const updateMultiplier = createAction(ERoundActions.UpdateMultiplier, props<{ multiplier: number }>());
export const clearRound = createAction(ERoundActions.ClearRound);
export const setAutoplayOptions = createAction(ERoundActions.SetAutoplayOptions, props<{ options: IAutoplayOptions }>());
export const removeAutoplayOptions = createAction(ERoundActions.RemoveAutoplayOptions, props<{ betIndex: number }>());
export const initialStateUpdate = createAction(ERoundActions.InitialStateUpdate, props<{ data: IRoundInitialState }>());
